import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgIf } from '@angular/common';

import { UNDERSCORE } from '../../../../shared/utils/constant';
import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { AqdbBatch } from '../../../models/aqdb-batch';
import { DatePipe } from '../../../../shared/pipes/date.pipe';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';

@Component({
	selector: 'copo-other-characteristics',
	templateUrl: './other-characteristics.component.html',
	styleUrl: '../aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatExpansionModule,
		TranslateModule,
		MatDividerModule,
		DatePipe,
		NumberPipe
	]
})
export class OtherCharacteristicsComponent {
	@Input() batchData?: AqdbBatch;
	readonly UNDERSCORE = UNDERSCORE;
}
